// extracted by mini-css-extract-plugin
module.exports = {"w1ww1e1d":"w1ww1e1d"};